// ---------------------------------------------------------------------------
// A pálya címe és elérhetősége, a felület oldaláról.
//
// Az EGYETLEN forrás a `functions/src/lib/venue.json`: a levelek (`functions/src/lib/venue.js`)
// és a felület is azt olvassa. Azért a functions csomagban áll, mert telepítéskor csak az a
// mappa kerül a szerverre, a Vite viszont bárhonnan importál. Ez a modul csak típust ad rá; a
// cím is kész alakban áll a JSON-ban, így a két oldalon nincs összefűző kód, ami eltérhetne.
// A lábléc, a főoldal és a foglalás kimenetelének kártyája (`VenueContactItem`) innen olvas;
// a `functions/test/venue.test.js` elbukik, ha valahol beégetve áll a cím, egy telefonszám
// vagy az e-mail cím.
// ---------------------------------------------------------------------------

import venue from "../../functions/src/lib/venue.json";

export interface VenuePhone {
  /** Ahogy kiírjuk */
  display: string;
  /** `tel:` linkhez, nemzetközi alakban */
  tel: string;
  /** Mire való a szám */
  label: string;
}

export interface Venue {
  name: string;
  /** A teljes cím egy sorban, irányítószámmal */
  address: string;
  /** Irányítószám nélkül, ahol kevés a hely (a főoldal hero-ja) */
  shortAddress: string;
  email: string;
  phones: VenuePhone[];
  facebookUrl: string;
  instagramUrl: string;
  facebookReviewUrl: string;
  googleReviewUrl: string;
}

// `satisfies`: ha a JSON-ból kiesik vagy átnevezik egy mező, a build itt bukik el, nem a
// felületen egy üres sorral
export const VENUE: Venue = venue satisfies Venue;

/** A cím a Google Térképen. */
export const VENUE_MAP_URL = `https://maps.google.com/?q=${encodeURIComponent(VENUE.address)}`;
